module.exports = __webpack_public_path__ + "img/logo.bc1b9336.png";